import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  FormControlLabel,
  Menu,
  MenuItem,
  Switch,
  TextField,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { viewImage } from "../../utils/viewPDF";
import { useOrganization } from "../../utils/OrganizationContext";
import NotificationAccess from "../../utils/NotificationAccess";
import { LeadSearch, NewMenu, PlanBadge } from "../../utils/NavbarTools";
import ErrorModal from "../../utils/ErrorModal";

// Same routes and role rules as the sidebar's Create group.
const NEW_ITEMS = [
  { group: "Work", label: "Lead", path: "/dashboard/add-lead", roles: ["PROJECT_HEAD", "SALESPERSON", "TELECALLER"] },
  { group: "Work", label: "Reminder", path: "/dashboard/reminder/add-reminder", roles: ["PROJECT_HEAD", "SALESPERSON", "TELECALLER", "MARKETER"] },
  { group: "Work", label: "Inventory", path: "/dashboard/inventory/add-inventory", roles: ["PROJECT_HEAD", "SALESPERSON"] },
  { group: "Setup", label: "Partner", path: "/dashboard/add-partner", roles: ["PROJECT_HEAD", "SALESPERSON"] },
  { group: "Setup", label: "Lead structure", path: "/dashboard/create-structure", roles: ["PROJECT_HEAD"] },
];

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const LINE = "#E4E9EF";
const FIELD_EDGE = "#D5DEE7";
const PRIMARY = "#0B5C8A";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const UserNavbar = ({ projectId, setProjectId }) => {
  const { role: roleForNew } = useOrganization();
  const [user, setUser] = useState();
  const [org, setOrg] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [fileUrl, setFileUrl] = useState("");
  const isMobile = useMediaQuery("(max-width: 750px)");
  const [projects, setProjects] = useState();
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState(
    JSON.parse(localStorage.getItem("org")) || "",
  );
  const { changeOrganization } = useOrganization();

  // Modal (replaces alert)
  const [subEndOpen, setSubEndOpen] = useState(false);
  const handleSubEndClose = () => {
    setSubEndOpen(false);
    localStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/get-all-org?username=${storedUser.username}`,
          {
            headers: {
              Authorization: `Bearer ${storedUser.accessToken}`,
            },
          },
        );

        setOrganizations(res.data);

        let orgId = JSON.parse(localStorage.getItem("org"));

        if (!orgId && res.data.length > 0) {
          orgId = res.data[0].orgId;
          localStorage.setItem("org", JSON.stringify(orgId));
        }

        setSelectedOrgId(orgId);
      } catch (err) {
        console.log(err);
      }
    };

    fetchOrganizations();
  }, []);

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}&orgId=${selectedOrgId}`,
          {
            headers: { Authorization: `Bearer ${storedUser.accessToken}` },
          },
        );
        setUser(res.data);
        localStorage.setItem("name", JSON.stringify(res.data.name));
      } catch (error) {
        console.log(error);
        navigate("/");
        localStorage.clear();
      }
    };
    getUser();
  }, [selectedOrgId]);

  useEffect(() => {
    if (!selectedOrgId) return;
    const getOrg = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/get-org?username=${storedUser.username}&orgId=${selectedOrgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        if (
          res.data.subscription !== "FREE" &&
          res.data.subscriptionEndDate < new Date().toISOString().split("T")[0]
        ) {
          // Logout happens when the user clicks OK on the modal
          setSubEndOpen(true);
          return;
        }
        setOrg(res.data);
        localStorage.setItem("org", JSON.stringify(res.data.orgId));
        localStorage.setItem("subs", JSON.stringify(res.data.subscription));
        // Org logo is hidden in the navbar, so it is no longer fetched here
        // (the failed fetch was showing an error on every page).
        // if (res.data.orgLogo) {
        //   const url = await viewImage(res.data.orgLogo, storedUser);
        //   setFileUrl(url);
        // }
      } catch (error) {
        console.error("Error fetching organization:", error);
      }
    };
    getOrg();
    // After a successful payment the result page fires "plan-changed" → re-read the org (badge updates).
    window.addEventListener("plan-changed", getOrg);
    return () => window.removeEventListener("plan-changed", getOrg);
  }, [selectedOrgId]);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/project/team/all?orgId=${selectedOrgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setProjects(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProjects();
  }, []);
  return (
    <Box
      sx={{
        background: "#ffffff",
        borderBottom: `1px solid ${LINE}`,
        position: "sticky",
        top: 0,
        zIndex: 20,
        fontFamily: FONT,
        color: INK,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "end", sm: "space-between" },
          alignItems: "center",
          gap: 2,
          minHeight: 56,
          pl: isMobile ? 7 : 3,
          pr: isMobile ? 2 : 3,
          py: 1,
        }}
      >
        {!isMobile && (
          <div style={{ minWidth: 0 }}>
            {org && (
              <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                {/* Organization logo hidden — showed a broken-image placeholder.
                {fileUrl && (
                  <img
                    src={fileUrl && fileUrl}
                    alt="Organization Logo"
                    style={{ height: 28, width: "auto", borderRadius: 7, objectFit: "contain", flexShrink: 0 }}
                  />
                )} */}
                <p
                  style={{
                    margin: 0,
                    display: "inline-flex",
                    alignItems: "center",
                    height: 30,
                    padding: "0 12px",
                    maxWidth: 260,
                    background: "#EAF2FB",
                    border: "1px solid #C9DEF3",
                    borderRadius: 999,
                    color: "#1B4F82",
                    fontFamily: FONT,
                    fontSize: 13,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    gap: 6,
                  }}
                >
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{org.orgName}</span>
                  <PlanBadge plan={org.subscription} />
                </p>
              </div>
            )}
          </div>
        )}
        <Box sx={{ display: "flex", alignItems: "center", columnGap: 1.5, flex: "1 1 auto", minWidth: 0, justifyContent: "center" }}>
          {!isMobile && (
            <>
              <Autocomplete
                style={{ width: 300, marginBottom: 0 }}
                name="projectId"
                options={projects || []}
                getOptionLabel={(option) => option.projectName || ""}
                value={projects?.find((p) => p.projectId === projectId) || null}
                onChange={(e, value) => {
                  setProjectId(value?.projectId || "");
                  localStorage.setItem(
                    "projectId",
                    JSON.stringify(value?.projectId || ""),
                  );
                }}
                isOptionEqualToValue={(option, value) =>
                  option.projectId === value.projectId
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Project" />
                )}
                sx={{
                  margin: 0,
                  "& .MuiInputBase-root": {
                    height: 36,
                    fontFamily: FONT,
                    fontSize: "13.5px",
                    fontWeight: 600,
                    color: INK,
                    borderRadius: "9px",
                    padding: "0 7px !important",
                    background: "#FFFFFF",
                  },
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: FIELD_EDGE },
                  "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#B4C6DA" },
                  "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: PRIMARY,
                    borderWidth: 1,
                  },
                  "& .MuiInputBase-input::placeholder": { color: "#8A97A8", fontWeight: 500, opacity: 1 },
                }}
                slotProps={{
                  paper: {
                    sx: {
                      mt: 0.5,
                      borderRadius: "12px",
                      border: `1px solid ${LINE}`,
                      boxShadow: "0 16px 36px -12px rgba(15,27,42,0.24)",
                      "& .MuiAutocomplete-option": {
                        fontFamily: FONT,
                        fontSize: 13.5,
                        borderRadius: "8px",
                        mx: 0.75,
                      },
                      "& .MuiAutocomplete-option[aria-selected='true']": {
                        background: "#EAF2FB !important",
                        color: "#1B4F82",
                        fontWeight: 700,
                      },
                    },
                  },
                }}
              />
            </>
          )}
        </Box>
        {!isMobile && (
          <LeadSearch
            orgId={org?.orgId || JSON.parse(localStorage.getItem("org"))}
            projectId={projectId}
            token={JSON.parse(localStorage.getItem("user"))?.accessToken}
            width={300}
          />
        )}
        <NewMenu
          groups={["Work", "Setup"].map((g) => ({
            title: g,
            items: NEW_ITEMS.filter((i) => i.group === g && i.roles.includes(roleForNew)),
          }))}
        />
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1.25,
            fontFamily: FONT,
            fontSize: 13.5,
            fontWeight: 600,
            color: INK,
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          {!isMobile && user && user.name}
          <Avatar
            {...stringAvatar(`${user && user.name}`)}
            onClick={handleAvatarClick}
            sx={{
              cursor: "pointer",
              width: 32,
              height: 32,
              background: INK,
              color: "#FFFFFF",
              fontFamily: MONO,
              fontSize: 11.5,
              fontWeight: 600,
              transition: "box-shadow .15s",
              boxShadow: open ? "0 0 0 3px #C9DEF3" : "none",
              "&:hover": { boxShadow: "0 0 0 3px #EAF2FB" },
            }}
          />
          {/* <NotificationsNoneIcon /> */}
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              "& .MuiPaper-root": {
                mt: 1,
                minWidth: 240,
                borderRadius: "12px",
                border: `1px solid ${LINE}`,
                boxShadow: "0 16px 36px -12px rgba(15,27,42,0.24)",
              },
              "& .MuiList-root": { p: 0.75 },
              "& .MuiMenuItem-root": {
                fontFamily: FONT,
                fontSize: 13.5,
                fontWeight: 500,
                color: INK_2,
                borderRadius: "8px",
                minHeight: 36,
                px: 1.25,
                "&:hover": { background: "#F4F7FA", color: INK },
              },
              "& .MuiMenuItem-root.Mui-selected": {
                background: "#EAF2FB",
                color: "#1B4F82",
                fontWeight: 700,
                "&:hover": { background: "#DCEAF8" },
              },
            }}
          >
            <MenuItem>
              <NotificationAccess
                orgIds={organizations.map((item) => item.orgId)}
                variant="menu"
              />
            </MenuItem>
            {organizations.length > 0 && (
              <>
                <MenuItem
                  disabled
                  sx={{
                    "&.Mui-disabled": { opacity: 1 },
                    minHeight: "28px !important",
                    mt: 0.5,
                    borderTop: "1px solid #EDF1F5",
                    borderRadius: "0 !important",
                    pt: 1.25,
                    "& strong": {
                      fontFamily: MONO,
                      fontSize: 10,
                      fontWeight: 500,
                      letterSpacing: "0.11em",
                      textTransform: "uppercase",
                      color: "#7B8A9C",
                    },
                  }}
                >
                  <strong>My Organizations</strong>
                </MenuItem>

                {organizations.map((item) => (
                  <MenuItem
                    key={item.orgId}
                    selected={item.orgId === selectedOrgId}
                    onClick={async () => {
                      await changeOrganization(item.orgId);
                      setSelectedOrgId(item.orgId);
                      localStorage.removeItem("projectId");
                      navigate("/dashboard");
                      handleClose();
                    }}
                  >
                    {item.orgName}
                  </MenuItem>
                ))}
              </>
            )}
            <MenuItem
              onClick={handleLogout}
              sx={{
                mt: 0.5,
                borderTop: "1px solid #EDF1F5",
                color: "#A6342A !important",
                fontWeight: "700 !important",
                "&:hover": { background: "#FBEDEB !important" },
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Box>

      <ErrorModal
        open={subEndOpen}
        handleClose={handleSubEndClose}
        msg="Your organization's subscription has ended. Please contact the admin."
        type="error"
      />
    </Box>
  );
};

export default UserNavbar;